/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListStockImagesParams,
  SchemaValidationErrorResponse,
  StockImageResults
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Search Stock Images
 */
export const listStockImages = (
    params: MaybeRefOrGetter<ListStockImagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<StockImageResults>(
      {url: `/stock_images`, method: 'GET',
        params, signal
    },
      );
    }




export const getListStockImagesInfiniteQueryKey = (params?: MaybeRefOrGetter<ListStockImagesParams>,) => {
    return [
    'infinite', 'stock_images', ...(params ? [params] : [])
    ] as const;
    }

export const getListStockImagesQueryKey = (params?: MaybeRefOrGetter<ListStockImagesParams>,) => {
    return [
    'stock_images', ...(params ? [params] : [])
    ] as const;
    }


export const getListStockImagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listStockImages>>, ListStockImagesParams['page']>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params: MaybeRefOrGetter<ListStockImagesParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listStockImages>>, TError, TData, QueryKey, ListStockImagesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListStockImagesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockImages>>, QueryKey, ListStockImagesParams['page']> = ({ signal, pageParam }) => listStockImages({...toValue(params), 'page': pageParam ?? toValue(params)?.['page']}, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listStockImages>>, TError, TData, QueryKey, ListStockImagesParams['page']>
}

export type ListStockImagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listStockImages>>>
export type ListStockImagesInfiniteQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Search Stock Images
 */

export function useListStockImagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listStockImages>>, ListStockImagesParams['page']>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params: MaybeRefOrGetter<ListStockImagesParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listStockImages>>, TError, TData, QueryKey, ListStockImagesParams['page']>>, }
 , queryClient?: QueryClient
 ): UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStockImagesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export const getListStockImagesQueryOptions = <TData = Awaited<ReturnType<typeof listStockImages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params: MaybeRefOrGetter<ListStockImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStockImages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListStockImagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStockImages>>> = ({ signal }) => listStockImages(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStockImages>>, TError, TData>
}

export type ListStockImagesQueryResult = NonNullable<Awaited<ReturnType<typeof listStockImages>>>
export type ListStockImagesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Search Stock Images
 */

export function useListStockImages<TData = Awaited<ReturnType<typeof listStockImages>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params: MaybeRefOrGetter<ListStockImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStockImages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStockImagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






